import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1129.418,1017.4577 L903.538,1017.4577 L903.538,904.5187 C903.538,842.2877 954.248,791.5777 1016.479,791.5777 C1078.708,791.5777 1129.418,842.2877 1129.418,904.5187 L1129.418,1017.4577 Z M1242.358,1017.4577 L1242.358,904.5187 C1242.358,779.9447 1141.051,678.6377 1016.479,678.6377 C891.905,678.6377 790.598,779.9447 790.598,904.5187 L790.598,1017.4577 L677.657,1017.4577 L677.657,1412.7487 C677.657,1506.1497 753.666,1582.1597 847.067,1582.1597 L1185.888,1582.1597 C1279.29,1582.1597 1355.299,1506.1497 1355.299,1412.7487 L1355.299,1017.4577 L1242.358,1017.4577 Z",
  transform: "translate(0 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1468.2393,339.8176 C1458.0743,339.8176 1447.9103,342.0766 1437.7453,343.2056 C1368.8503,144.4306 1181.3713,0.9966 960.0083,0.9966 C696.8573,0.9966 482.2703,202.0306 457.4243,458.4046 C437.0943,455.0166 415.6353,452.7566 395.3063,452.7566 C150.2263,452.7566 -43.4667,676.9436 8.4863,930.9466 C46.3213,1115.8296 217.9903,1243.3386 406.6003,1243.3386 L564.7173,1243.3386 L564.7173,960.9876 C564.7173,929.8166 590.0153,904.5176 621.1873,904.5176 L677.6573,904.5176 C677.6573,718.1666 830.1263,565.6976 1016.4783,565.6976 C1202.8293,565.6976 1355.2993,718.1666 1355.2993,904.5176 L1411.7693,904.5176 C1442.9393,904.5176 1468.2393,929.8166 1468.2393,960.9876 L1468.2393,1243.3386 C1717.8373,1243.3386 1920.0003,1041.1756 1920.0003,791.5786 C1920.0003,541.9806 1717.8373,339.8176 1468.2393,339.8176",
  transform: "translate(0 168)"
}));

var IconCloudLockSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCloudLockSolid, _Component);

  var _super = _createSuper(IconCloudLockSolid);

  function IconCloudLockSolid() {
    _classCallCheck(this, IconCloudLockSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCloudLockSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCloudLock",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCloudLockSolid.displayName = "IconCloudLockSolid";
  return IconCloudLockSolid;
}(Component);

IconCloudLockSolid.glyphName = 'cloud-lock';
IconCloudLockSolid.variant = 'Solid';
IconCloudLockSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCloudLockSolid;
export { IconCloudLockSolid };